import { BenchmarkRankService } from "../service/asyncBatchBenchmarkRankService";
import * as validations from "../utils/validations";

export class BenchmarkRankFunctions {
  fnBurgissCalcPooledRankingIRR(
    investId?: any[][],
    idType?: string,
    beginDate?: any,
    endDate?: any,
    currency?: string,
    selectionSetId?: any,
    filter?: any,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requirReportedValuation?: any,
    stopOn?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (investId.toString() == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    idType = validations.getIdType(idType);
    endDate = validations.isValidEndDate(endDate);

    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);

      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }
    }
    const dateCmp = validations.dateCompare(beginDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }

    if (idType.toString() == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    sampleStatistic = validations.valSampleStatisticsRank(sampleStatistic, "RANK");
    if (sampleStatistic.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + sampleStatistic.toString().replace("Error", "");
    }

    rankValue = validations.valSampleStatisticsForRankValueTwoDecimal(rankValue);
    if (String(rankValue) == "-1") {
      return "Error Invalid Input RankValue";
    }

    numSimulations = validations.valNumsimulationRank(numSimulations);
    if (String(numSimulations) == "-1") {
      return "Error Invalid Input Num simulation";
    }
    desiredSampleSize = validations.valDesiredSampleSize(desiredSampleSize);
    if (String(desiredSampleSize) == "-1") {
      return "Error Invalid Input Desired Sample Size";
    }

    requirReportedValuation = validations.validateReportedValuationRank(requirReportedValuation);
    stopOn = validations.valStopOnRank(stopOn);
    if (String(stopOn) == "-1") {
      return "Error Invalid Input stopOn";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    // eslint-disable-next-line no-constant-condition
    if (String(selectionSetId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid selection SetID";
    }

    return new BenchmarkRankService().burgissCalcPooledRankingIRR(
      investId,
      idType,
      beginDate,
      endDate,
      baseorlocalcurrency,
      selectionSetId,
      filter,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requirReportedValuation,
      stopOn,
      alternateCurrrency,
      uniqueCellId
    );
  }

  fnBurgissCalcPooledRankingTWRR(
    investId?: any[][],
    idType?: string,
    startDate?: any,
    endDate?: any,
    currency?: string,
    selectionSetId?: any,
    filter?: any,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requirReportedValuation?: any,
    stopOn?: any,

    uniqueCellId?: string,
    advancedParameter?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (investId.toString() == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    idType = validations.getIdType(idType);

    endDate = validations.isValidEndDate(endDate);

    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    const minDate = new Date(0).toLocaleDateString();
    const validStartDate = validations.isValidBeginDate(startDate);
    if (validStartDate === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const bDate: boolean = validations.searchedDateInMeasurementDate(validStartDate, "S");
    startDate = bDate == true ? validStartDate : minDate;
    const dateCmp = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }

    if (idType.toString() == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    sampleStatistic = validations.valSampleStatisticsRank(sampleStatistic, "RANK");
    if (sampleStatistic.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + sampleStatistic.toString().replace("Error", "");
    }

    numSimulations = validations.valNumsimulationRank(numSimulations);
    if (String(numSimulations) == "-1") {
      return "Error Invalid Input Num simulation";
    }
    desiredSampleSize = validations.valDesiredSampleSize(desiredSampleSize);
    if (String(desiredSampleSize) == "-1") {
      return "Error Invalid Input Desired Sample Size";
    }
    rankValue = validations.valSampleStatisticsForRankValueTwoDecimal(rankValue);
    if (String(rankValue) == "-1") {
      return "Error Invalid Input RankValue";
    }
    requirReportedValuation = validations.validateReportedValuationRank(requirReportedValuation);
    stopOn = validations.valStopOnRank(stopOn);
    if (String(stopOn) == "-1") {
      return "Error Invalid Input stopOn";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    // eslint-disable-next-line no-constant-condition
    if (String(selectionSetId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid selection SetID";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    return new BenchmarkRankService().burgissCalcPooledRankingTWRR(
      investId,
      idType,
      startDate,
      endDate,
      baseorlocalcurrency,
      selectionSetId,
      filter,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requirReportedValuation,
      stopOn,
      alternateCurrrency,
      uniqueCellId,
      advancedParameter
    );
  }

  fnBurgissCalcPooledRankingDPI(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requirReportedValuation?: any,
    stopOn?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (investId.toString() == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    idType = validations.getIdType(idType);

    endDate = validations.isValidEndDate(endDate);

    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    if (idType.toString() == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    sampleStatistic = validations.valSampleStatisticsRank(sampleStatistic, "RANK");
    if (sampleStatistic.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + sampleStatistic.toString().replace("Error", "");
    }

    numSimulations = validations.valNumsimulationRank(numSimulations);
    if (String(numSimulations) == "-1") {
      return "Error Invalid Input Num simulation";
    }
    desiredSampleSize = validations.valDesiredSampleSize(desiredSampleSize);
    if (String(desiredSampleSize) == "-1") {
      return "Error Invalid Input Desired Sample Size";
    }
    rankValue = validations.valSampleStatisticsForRankValueTwoDecimal(rankValue);
    if (String(rankValue) == "-1") {
      return "Error Invalid Input RankValue";
    }
    requirReportedValuation = validations.validateReportedValuationRank(requirReportedValuation);
    stopOn = validations.valStopOnRank(stopOn);
    if (String(stopOn) == "-1") {
      return "Error Invalid Input stopOn";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    // eslint-disable-next-line no-constant-condition
    if (String(selectionSetId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid selection SetID";
    }

    return new BenchmarkRankService().burgissCalcPooledRankingDPI(
      investId,
      endDate,
      baseorlocalcurrency,
      idType,
      selectionSetId,
      filter,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requirReportedValuation,
      stopOn,
      alternateCurrrency,
      uniqueCellId
    );
  }

  fnBurgissCalcPooledRankingRVPI(
    investId?: any[][],
    idType?: string,
    endDate?: any,
    currency?: string,
    selectionSetId?: any,
    filter?: any,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requirReportedValuation?: any,
    stopOn?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (investId.toString() == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    idType = validations.getIdType(idType);

    endDate = validations.isValidEndDate(endDate);

    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    if (idType.toString() == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    sampleStatistic = validations.valSampleStatisticsRank(sampleStatistic, "RANK");
    if (sampleStatistic.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + sampleStatistic.toString().replace("Error", "");
    }

    numSimulations = validations.valNumsimulationRank(numSimulations);
    if (String(numSimulations) == "-1") {
      return "Error Invalid Input Num simulation";
    }
    desiredSampleSize = validations.valDesiredSampleSize(desiredSampleSize);
    if (String(desiredSampleSize) == "-1") {
      return "Error Invalid Input Desired Sample Size";
    }
    rankValue = validations.valSampleStatisticsForRankValueTwoDecimal(rankValue);
    if (String(rankValue) == "-1") {
      return "Error Invalid Input RankValue";
    }
    requirReportedValuation = validations.validateReportedValuationRank(requirReportedValuation);
    stopOn = validations.valStopOnRank(stopOn);
    if (String(stopOn) == "-1") {
      return "Error Invalid Input stopOn";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    // eslint-disable-next-line no-constant-condition
    if (String(selectionSetId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid selection SetID";
    }

    return new BenchmarkRankService().burgissCalcPooledRankingRVPI(
      investId,
      idType,
      endDate,
      baseorlocalcurrency,
      selectionSetId,
      filter,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requirReportedValuation,
      stopOn,
      alternateCurrrency,
      uniqueCellId
    );
  }

  fnBurgissCalcPooledRankingTVPI(
    investId?: any[][],
    idType?: string,
    endDate?: any,
    currency?: string,
    selectionSetId?: any,
    filter?: any,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requirReportedValuation?: any,
    stopOn?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (investId.toString() == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    idType = validations.getIdType(idType);

    endDate = validations.isValidEndDate(endDate);

    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    if (idType.toString() == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    sampleStatistic = validations.valSampleStatisticsRank(sampleStatistic, "RANK");
    if (sampleStatistic.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + sampleStatistic.toString().replace("Error", "");
    }

    numSimulations = validations.valNumsimulationRank(numSimulations);
    if (String(numSimulations) == "-1") {
      return "Error Invalid Input Num simulation";
    }
    desiredSampleSize = validations.valDesiredSampleSize(desiredSampleSize);
    if (String(desiredSampleSize) == "-1") {
      return "Error Invalid Input Desired Sample Size";
    }
    rankValue = validations.valSampleStatisticsForRankValueTwoDecimal(rankValue);
    if (String(rankValue) == "-1") {
      return "Error Invalid Input RankValue";
    }
    requirReportedValuation = validations.validateReportedValuationRank(requirReportedValuation);
    stopOn = validations.valStopOnRank(stopOn);
    if (String(stopOn) == "-1") {
      return "Error Invalid Input stopOn";
    }

    selectionSetId = validations.isValidSelectionId(selectionSetId);
    // eslint-disable-next-line no-constant-condition
    if (String(selectionSetId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid selection SetID";
    }

    return new BenchmarkRankService().burgissCalcPooledRankingTVPI(
      investId,
      idType,
      endDate,
      baseorlocalcurrency,
      selectionSetId,
      filter,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requirReportedValuation,
      stopOn,
      alternateCurrrency,
      uniqueCellId
    );
  }
}
